<template>
  <!-- <div>
    <div class="head">
        Panasonic
    </div>
    <div class="title">
        <span>松下开关插座</span>
        <span class="title-weight">官网查询平台</span>
    </div>
    <div class="security">
        <p>
        <span>防伪码</span>
        <input type="text" maxlength="24" v-model="model.code" placeholder="请输入24位防伪码">
        </p>
    </div>
    <div class="security code">
        <span>验证码</span>
        <input type="text" maxlength="4" v-model="model.verifyCode" placeholder="请输入验证码">
    </div>
    <div class="verification">
      <span>
        <img  :src="model.imgVerifyCode" alt>
      </span>
      <span @click="refreshCode">看不清楚，换一个</span>
    </div>
    <div class="btn">
        <button @click="digitSubmit">查 询</button>
        <button @click="btnclear">重 置</button>
    </div>
  </div> -->

<div class="searchright">
		<div class="righttitle">松下开关插座防伪查询平台</div>
		<div class="rightitlteline"></div>
		<div class="h25">2019年6月1日后生产的曲悦/佳典纯/适享系列；</div>
    <div class="h25">2019年7月1日后生产的新适佳/铭悦/佳典饰/新姿彩/铭适/智趣/悦趣/简尚系列；</div>
    <div class="h25">请在此处查询真伪（生产日期详见产品本体）</div>
		<div class="rightcontent">带<span style="color: red;">*</span>号部分是必须填写的</div>
		<div class="h20"></div>
		<div class="rightentercontent">
				<span>24位防伪码<span style="color: red;">*</span></span>
				<input type="text" class="entercode" maxlength="24" v-model="model.code">
				<div class="eeclearfix"></div>
		</div>
    <div class="rightentercontent">
				<span>验证码<span style="color: red;">*</span></span>
				<input type="text" class="entercode" maxlength="4" v-model="model.verifyCode">
				<div class="eeclearfix"></div>
		</div>
    <div class="verifycode">
      <img  :src="model.imgVerifyCode" alt>
			<span @click="refreshCode">看不清楚，换一个</span>
		</div>
		<div class="buttonarea">
			<div class="searchbut" @click="digitSubmit">查询</div>
			<div class="resetbut" @click="btnclear">重置</div>
		</div>
		<!-- <div class="srresult" v-show="model.showDesc">
			感谢您购买松下开关插座！为保证您的合法权益，请参照一下方法确认您购买的商品是否为正品；<br>
      第一步：确认您购买的产品是否有防伪码。每个产品的数字防伪都是唯一的，由系统随机生成，不连续、不重复。<br>
      第二步：通过以下两种方法，查询防伪码是否有效。<br>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;方法一：扫描产品包装上的二维码，链接至查询页面，输入20位数字防伪码，即可获得查询结果。<br>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;方法二：登陆防伪查询网http://pro.panasonic.cn/service/fangwei输入24位数字防伪码即可获得查询结果。
		</div> -->
		
		 <div class="rightresult" v-show="model.showResult">
      产品编码：{{res.proNo}}<br>
      查询结果：{{res.searchResult}}<br>
      产品名称：{{res.proName}}<br><br>
      <span style="color: red;">
        提示：{{res.message}}</span>
    </div> 
		
	</div>

</template>

 <style lang="scss" scope>
@import "../static/css/panasonic/search.css";
</style>
<script>
import { getQueryFirst } from "@/js/tool.js";
import { Cookie } from "@/js/util.js";
import api from "../webapi/queryApi";
import { mapState, mapActions, mapMutations,mapGetters } from "vuex";
export default {
  data() {
    return {
      errorMsg: "",
      model: {
        code: "", 
        verifyCode: "",
        imgVerifyCode:'',
        showDesc: true,
        showResult: false
      },
      res: {
        proNo: "",
        searchResult: "编码错误",
        proName: "",
        message: "",
      }
    };
  },
  computed: {
    // ...mapState(["WX"]),
    //...mapGetters(["get_wx"])
  },
  created() {
    // var _ = this;
    // _.clearModel(_.model);
    // var code = getQueryFirst("code");
    // if(code.length<=10){
    //   //alert('请跳转正确的入口');
    //   //return;
    // }
    // code = code.substring(1, 25);
  },
  mounted() {
    this.AuthCode();
  },
  methods: {
    ...mapMutations(["set_dialog", "switch_dialog"]),
    clearModel: function() {
      var _ = this;
      for (const key in _.model) {
        if(key != "imgVerifyCode"){
          _.model[key] = "";
        }
      }
    },
    AuthCode:function(){
      var _=this;
      api
        .get_ValidCode()
        .then(res =>{
            if(res.success){
               _.model.imgVerifyCode = 'data:image/png;base64,'+res.result.verifyCode;
            }
        });
    },
    valid: function() {
      var _ = this;
      var m = _ .model;
      var msg = "";
      if (m.code == "") {
        msg = "请输入防伪码";
      }
      else if (m.code.length != 24) {
        msg = "防伪码格式不正确";
      }
      else if (m.verifyCode == "") {
        msg = "请输入验证码";
      }
      else if (m.verifyCode.length != 4) {
        msg = "验证码格式不正确";
      }
      if (msg) {
        alert(msg);
        return false;
      }
      return true;
    },
    digitSubmit: function() {
      var _ = this;
      _.model.showDesc = true;
      _.model.showResult = false;
      if (_.valid()) {
        api.get_ConsumersScanProductInfo({
          code: _.model.code,
          ValidCode: _.model.verifyCode,
          // openId:_.WX.openId,
          // GPS: JSON.parse(Cookie.getCookie("gps"))
        })
        .then(res => {
          if (res.success) {
            _.res = res.result;
            _.model.showDesc = false;
            _.model.showResult = true;
          } else {
            var msg = res.error.message;
            alert(msg);
          }
        })          
      }
    },
    refreshCode: function() {
      this.AuthCode();
    },
    btnclear:function()
    {      
      this.clearModel(this.model);
    }
  }
};
</script>

<style scoped>
</style>